"use client";
import { Button } from "@kyan/ui";

import { ConnectWalletWrapper } from "#/components/ConnectWalletWrapper/ConnectWalletWrapper";

import { useRFQTradeButtonController } from "./RFQTradeButton.controller";

export const RFQTradeButton: React.FC = () => {
  const { buttonLabel, isLoading, isDisabled, handleTrade } =
    useRFQTradeButtonController();

  return (
    <ConnectWalletWrapper>
      <Button
        size="lg"
        disabled={isDisabled}
        isLoading={isLoading}
        className="mt-2 w-full text-[15px] shadow-none"
        onClick={handleTrade}
      >
        {buttonLabel}
      </Button>
    </ConnectWalletWrapper>
  );
};
